/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';

/**
 * Dialog shown when a clicked location cannot be resolved to a road in the map data
 * (the segment lookup returns 404). Informs the user the road could not be found,
 * which can happen with small, private, or new roads.
 */
@Component({
  selector: 'fm-road-not-available-dialog',
  templateUrl: './road-not-available-dialog.component.html',
  styleUrls: ['./road-not-available-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoadNotAvailableDialogComponent {
  constructor(public dialogRef: MatLegacyDialogRef<RoadNotAvailableDialogComponent>) {}

  /** Closes the dialog. */
  public onClose(): void {
    this.dialogRef.close();
  }
}
